import React from 'react'
import { defaultLogo } from '../../env'
import { FileIcon } from '../../assets/Icons'

const Releases = () => {
  return (
    <>
    <div className='ReleaseHead'>
      <h1>Releases</h1>
    </div>
    <div className='releasebody my-4'>
      <div className='row '>
      <div className='col-md-2'>
        <div className='releasedata'>
            <p> 2 months ago </p>
            <p>
                    <img src={defaultLogo}></img>
                    Ritik Sahni
            </p>
            <p className='d-flex'>
                <FileIcon/>  2.35
            </p>
        </div>
      </div>
      <div className='col-md-10'>
        <div className='releasebox'>
          <div className='releaseinfo border-0'>
            <div className='d-flex py-3 pb-2 justify-content-between pb-4'>
                <div>
                    <h3 className='mb-0'> Version: 2.35 </h3>
                    <p className='timeversion mb-0'> 2 months ago </p>
                </div>
                <div className='d-flex justify-content-between  text-end'>
                    <a download>filename.zip</a>
                </div>
            </div>
          </div>
          <div className='releasecmnt'>
            <p>Change in blockade, walkable, Video material and Audio source</p>
          </div>
        </div>
      </div>
      </div>   
    </div>
    <div className='releasebody my-4'>
      <div className='row '>
      <div className='col-md-2'>
        <div className='releasedata'>
            <p> 2 months ago </p>
            <p>
                    <span className='small-initials'>
                    RS
                    </span>
                    Ritik Sahni
            </p>
            <p className='d-flex'>
                <FileIcon/>  2.35
            </p>
        </div>
      </div>
      <div className='col-md-10'>
        <div className='releasebox'>
          <div className='releaseinfo border-0'>
            <div className='d-flex py-3 pb-2 justify-content-between pb-4'>
                <div>
                    <h3 className='mb-0'> Version: 2.35 </h3>
                    <p className='timeversion mb-0'> 2 months ago </p>
                </div>
                <div className='d-flex justify-content-between  text-end'>
                    <a download>filename.zip</a>
                </div>
            </div>
          </div>
          <div className='releasecmnt'>
            <p>Change in blockade, walkable, Video material and Audio source</p>
          </div>
        </div>
      </div>
      </div>   
    </div>
    </>
  )
}

export default Releases
